import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { environment } from 'environments/environment';

const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Material'

  },
  {
    title: 'Edit material'
   
  }
];

//const password = new FormControl('', Validators.required);
//const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'page-material-form-edit',
  templateUrl: './material-form-edit.html',
  styleUrls: ['./material-form-edit.scss']
})


export class PageMaterialEdit implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  selectcustomer: any;
  stateCtrl: FormControl;
  filteredStates: any;
  data: any;
  tm_id:string;
  rows=[];

  supplierStr: string;
  unitStr: string;
  colorStr: string;
  typeStr: string;
  message:string;
  modelStr:string;
  maxStr:string;
  minStr:string;
  lotsizeStr:string;
  specStr:string;
  partnameStr:string;
  partnoStr:string;
  priceStr:string;
  catalogStr:string;
  weightStr:string;
  sourceStr:string;
  statusStr:string;
  cuttingStr:string;
  lengthStr:string;
  //diaglog


  dialogRef: MdDialogRef<MaterialEditDialog>;
  selectedOption: string;


  types = [
    { value: 'PT', viewValue: 'PT' },
    { value: 'Part', viewValue: 'Part' },
    { value: 'RM', viewValue: 'RM' }
  ];

  groups = [
    { value: 'N/A', viewValue: 'N/A' },
    { value: 'Current', viewValue: 'Current' },
    { value: 'Service', viewValue: 'Service' },
    { value: 'New Model', viewValue: 'New Model' },
    { value: 'Deteriorate', viewValue: 'Feteriorate' },
  ];

  units = [
    { value: 'Pcs', viewValue: 'Pcs' },
    { value: 'Kg', viewValue: 'Kg' },
    { value: 'g', viewValue: 'g' },
    { value: 'Cm', viewValue: 'Cm' },
    { value: 'm', viewValue: 'm' },
    { value: 'mm', viewValue: 'mm' },
    { value: 'Can', viewValue: 'Can' },
    { value: 'Box', viewValue: 'Box' },
    { value: 'Roll', viewValue: 'Roll' },
    { value: 'Sheet', viewValue: 'Sheet' },
    { value: 'Blade', viewValue: 'Blade' }
  ];

  colors = [
    { value: 'N/A', viewValue: 'N/A' },
    { value: 'RED', viewValue: 'RED' },
    { value: 'BLACK', viewValue: 'BLACK' },
    { value: 'BLUE', viewValue: 'BLUE' }
  ];

  sources = [
    { value: 'N/A', viewValue: 'N/A' },
    { value: 'Service CKD', viewValue: 'Service CKD' },
    { value: 'Service LS', viewValue: 'Service LS' },
    { value: 'CKD', viewValue: 'CKD' },
    { value: 'LS', viewValue: 'LS' },
    { value: 'Plating parts', viewValue: 'Plating parts' },
    { value: 'SUB ASSY', viewValue: 'SUB ASSY' },
    { value: 'WIP(CU)', viewValue: 'WIP(CU)' },
    { value: 'WIP(PRESS)', viewValue: 'WIP(PRESS)' },
    { value: 'WIP(SP)', viewValue: 'WIP(SP)' },
    { value: 'WIP(TC)', viewValue: 'WIP(TC)' }
  ];

 

  suppliers = [];
  catalogs =[];
  imageSrc:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  //uploader:any;
  Name:string; 
  myFile:File; /* property of File type */

  constructor(private activatedRoute: ActivatedRoute,public dialog: MdDialog,private fb: FormBuilder, private _sharedService: SharedService,private router: Router) {
    this._sharedService.emitChange(this.pageTitle);
  
  }

  
    openDialog() {
    
    let dialogRef = this.dialog.open(MaterialEditDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.postString();
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

  filterStates(val: string) {
    this.supplierStr  = val;
    console.log('customerStr : ',this.supplierStr);
    return val ? this.suppliers.filter((s) => new RegExp(val, 'gi').test(s)) : this.suppliers;
  }


  onChange(type: string) {
    alert(type);
  }

fetch(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_material.php?id='+this.tm_id);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  fetchCatalog(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_material_catalog.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  fetchSupplier(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_supplier_name.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  postString() {

    if(this.myFile!=null){
      this.data = "length="+this.lengthStr+"&cutting="+this.cuttingStr+"&filename="+this.myFile.name+"&status="+this.statusStr+"&source="+this.sourceStr+"&weight="+this.weightStr+"&tm_id="+this.tm_id+"&catalog="+this.catalogStr+"&lotsize="+this.form.controls.lotsize.value+"&supplier="+this.supplierStr+"&unit=" + this.unitStr + "&color=" + this.colorStr + "&model=" + this.form.controls.model.value + "&partname=" + this.form.controls.partname.value + "&partno=" + this.form.controls.partno.value + "&max=" + this.form.controls.max.value + "&min=" + this.form.controls.min.value + "&spec=" + this.form.controls.spec.value + "&price=" + this.form.controls.price.value + "&type=" + this.typeStr;
    }else{
      this.data = "length="+this.lengthStr+"&cutting="+this.cuttingStr+"&status="+this.statusStr+"&source="+this.sourceStr+"&weight="+this.weightStr+"&tm_id="+this.tm_id+"&catalog="+this.catalogStr+"&lotsize="+this.form.controls.lotsize.value+"&supplier="+this.supplierStr+"&unit=" + this.unitStr + "&color=" + this.colorStr + "&model=" + this.form.controls.model.value + "&partname=" + this.form.controls.partname.value + "&partno=" + this.form.controls.partno.value + "&max=" + this.form.controls.max.value + "&min=" + this.form.controls.min.value + "&spec=" + this.form.controls.spec.value + "&price=" + this.form.controls.price.value + "&type=" + this.typeStr;
    }
   
   
    const req = new XMLHttpRequest();
    req.open('POST',  environment.url+'/api/editMaterial.php', true);

    //Send the proper header information along with the request
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    req.onreadystatechange = function () {//Call a function when the state changes.
      if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
        // Request finished. Do processing here.
        req.onload = () => {
          console.log(JSON.parse(req.response));
          //JSON.parse(req.response);
        };
      }
    }
    req.send(this.data);
    console.log('----data-----', this.data);

    if(this.myFile!=null){
      this.uploadPhoto(this.myFile);
    }
  this.router.navigateByUrl('default-layout/material');

  }


  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }


  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }

  getUnit(unit) {
    this.unitStr = unit;
  }
  getColor(color) {
    this.colorStr = color;
  }
  getSource(source){
    this.sourceStr = source;
  }
  getType(type) {
    this.typeStr = type;
  }
  getStatus(status) {
    this.statusStr = status;
  }
  getCatalog(catalog){
    this.catalogStr = catalog;

  }


  ngOnInit() {

this.activatedRoute.params.subscribe((params: Params) => {
        this.tm_id = params['id'];
        console.log('--id--',this.tm_id);
      });
  
      this.fetchCatalog((dataCatalog)=>{
          this.catalogs = dataCatalog;
      });

      
       this.fetch((data) => {
      // cache our list
     
      //this.model=data[0]['tp_productname'];
      // push our inital complete list

      console.log('------data------',data);
      this.rows = data;
      this.supplierStr = this.rows[0].tm_supplier;
      this.typeStr = this.rows[0].tm_type;
      this.partnameStr = this.rows[0].tm_part_name;
      this.partnoStr = this.rows[0].tm_part_no;
      this.colorStr = this.rows[0].tm_color;
      this.maxStr = this.rows[0].tm_stock_max;
      this.minStr = this.rows[0].tm_stock_min;
      this.modelStr = this.rows[0].tm_master;
      this.priceStr = this.rows[0].tm_price;
      this.specStr = this.rows[0].tm_spec;
      this.lotsizeStr = this.rows[0].tm_slit;
      this.lengthStr = this.rows[0].tm_length;
      this.cuttingStr = this.rows[0].tm_cutting;
      this.unitStr = this.rows[0].tm_unit;
      this.colorStr = this.rows[0].tm_color;
      this.catalogStr = this.rows[0].tb46_material_type_tb46_id;
      this.weightStr = this.rows[0].tm_weight;
      this.sourceStr = this.rows[0].tm_source;
      this.statusStr = this.rows[0].tm_catalog;
      
    });

    this.fetchSupplier((supplier) => {
      this.suppliers = supplier.map(function (val) {
        return [val.tb2_company_shortname]
      });
      //this.suppliers = supplier;
      console.log('------this.model------', this.suppliers);
    });


    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
      .startWith(null)
      .map(name => this.filterStates(name));


    this.form = this.fb.group({
      stateCtrl: [null, Validators.compose([Validators.required])],
      model: [null, Validators.compose([Validators.required])],
      partname: [null, Validators.compose([Validators.required])],
      partno: [null, Validators.compose([Validators.required])],
      max: [null, Validators.compose([Validators.required])],
      min: [null, Validators.compose([Validators.required])],
      type: [null, Validators.compose([Validators.required])],
      spec: [null, Validators.compose([Validators.required])],
      price: [null, Validators.compose([Validators.required])],
      lotsize: [null, Validators.compose([Validators.required])],
      cutting:[null, Validators.compose([Validators.required])],
      length:[null, Validators.compose([Validators.required])],
      weight: [null, Validators.compose([Validators.required])]
      //color: [null, Validators.compose([Validators.required])],
      // unit: [null, Validators.compose([Validators.required])]
      //email: [null, Validators.compose([Validators.required, CustomValidators.email])],
      //range: [null, Validators.compose([Validators.required, CustomValidators.range([5, 9])])],
      //url: [null, Validators.compose([Validators.required, CustomValidators.url])],
      //date: [null, Validators.compose([Validators.required, CustomValidators.date])],
      //creditCard: [null, Validators.compose([Validators.required, CustomValidators.creditCard])],
      //phone: [null, Validators.compose([Validators.required, CustomValidators.phone('en-US')])],
      //gender: [null, Validators.required],
      //password: password,
      //confirmPassword: confirmPassword
      

    });



  }
}

//dialog
@Component({
  selector: 'material-dialog',
  templateUrl: 'material-dialog.html',
})
export class MaterialEditDialog {
  jazzMessage = 'Jazzy jazz jazz';
  constructor(public dialogRef: MdDialogRef<MaterialEditDialog>) {}
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/material/material-form-edit.ts